import {
  CREATE_USER_ROLE_FAIL,
  CREATE_USER_ROLE_SUCCESS,
  CREATE_USER_ROLE_REQUEST,
  DELETE_USER_ROLE_FAIL,
  DELETE_USER_ROLE_REQUEST,
  DELETE_USER_ROLE_SUCCESS,
  GET_USER_ROLE_FAIL,
  GET_USER_ROLE_REQUEST,
  GET_USER_ROLE_SUCCESS,
  UPDATE_USER_ROLE_FAIL,
  UPDATE_USER_ROLE_REQUEST,
  UPDATE_USER_ROLE_SUCCESS,
} from "../../types/admin/userRoleTypes";

export const createUserRoleReducer = (state = {}, action) => {
    const { type, payload } = action;
    switch (type) {
      case CREATE_USER_ROLE_REQUEST:
        return {
          ...state,
          createUserRoleLoading: true,
        };
      case CREATE_USER_ROLE_SUCCESS:
        return {
          ...state,
          createUserRoleLoading: false,
          createUserRoleInfo: payload,
          createUserRoleError: "",
        };
      case CREATE_USER_ROLE_FAIL:
        return {
          ...state,
          createUserRoleLoading: false,
          createUserRoleInfo: [],
          createUserRoleError: payload,
        };
      default:
        return state;
    }
  };

  export const updateUserRoleReducer = (state = {}, action) => {
      const { type, payload } = action;
      switch (type) {
        case UPDATE_USER_ROLE_REQUEST:
          return {
            ...state,
            updateUserRoleLoading: true,
          };
        case UPDATE_USER_ROLE_SUCCESS:
          return {
            ...state,
            updateUserRoleLoading: false,
            updateUserRoleInfo: payload,
            updateUserRoleError: "",
          };
        case UPDATE_USER_ROLE_FAIL:
          return {
            ...state,
            updateUserRoleLoading: false,
            updateUserRoleInfo: [],
            updateUserRoleError: payload,
          };
        default:
          return state;
      }
    };
    
  export const getUserRoleReducer = (state = {}, action) => {
    const { type, payload } = action;
    switch (type) {
      case GET_USER_ROLE_REQUEST:
        return {
          ...state,
          getUserRoleLoading: true,
        };
      case GET_USER_ROLE_SUCCESS:
        return {
          ...state,
          getUserRoleLoading: false,
          getUserRoleInfo: payload,
          getUserRoleError: "",
        };
      case GET_USER_ROLE_FAIL:
        return {
          ...state,
          getUserRoleLoading: false,
          getUserRoleInfo: [],
          getUserRoleError: payload,
        };
      default:
        return state;
    }
  };
  
  export const deleteUserRoleReducer = (state = {}, action) => {
    const { type, payload } = action;
    switch (type) {
      case DELETE_USER_ROLE_REQUEST:
        return {
          ...state,
          deleteUserRoleLoading: true,
        };
      case DELETE_USER_ROLE_SUCCESS:
        return {
          ...state,
          deleteUserRoleLoading: false,
          deleteUserRoleInfo: payload,
          deleteUserRoleError: "",
        };
      case DELETE_USER_ROLE_FAIL:
        return {
          ...state,
          deleteUserRoleLoading: false,
          deleteUserRoleInfo: [],
          deleteUserRoleError: payload,
        };
      default:
        return state;
    }
  };